import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { UnauthorizedHandler } from '../unauthorized-handler';
import { generateExceptionRedirector } from '@patsnap/common-ps-http';
import { Site, SLD } from '@patsnap-utils/biz';
import { isInIframe } from '@telecom/shared/utils/in-iframe';
import { Logger } from '@patsnap/tahiti-core';
import { AiAgentEnvService } from '@telecom/shared/services/ai-agent-env-service/ai-agent-env-service';


@injectable()
export class UnauthorizedHandlerImpl implements UnauthorizedHandler {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(AiAgentEnvService)
        private readonly _aiAgentEnvService: AiAgentEnvService,
    ) { }

    handle(error: Error) {
        return generateExceptionRedirector(403, () => {
            if (this._aiAgentEnvService.isInAiAgentFlow) {
                this._logger.warn('运行在 AI Agent Flow 中，不进行 403 重定向');
                return;
            }
            const redirectUrl = this._getRedirectUrl();
            this.win.location.href = redirectUrl;
        })(error);
    }

    get win() {
        return isInIframe() ? window.parent : window;
    }

    private _getRedirectUrl() {
        if (isInIframe()) {
            return new Site({ sld: SLD.EUREKA, pathname: '403' }).href;
        }
        return new Site({ sld: SLD.ACCOUNT, pathname: 'user-settings/#/no-permission?from_site=ai-drafting' }).href;
    }
}
